import React from 'react';
import { useTranslation } from 'react-i18next';
import { ACCOUNT_TAB, TransactionTabType } from '../../Transactions.constants';
import * as S from './OperationsEmptyState.styles';

interface OperationsEmptyStateProps {
  activeTab: TransactionTabType;
}

export function OperationsEmptyState({ activeTab }: OperationsEmptyStateProps) {
  const { t } = useTranslation();
  const isAccountTab = activeTab === ACCOUNT_TAB;

  return (
    <S.Container>
      <S.Image
        src="/images/transactions-empty.png"
        alt={t('pages.cabinet.you_dont_have_any_operations_yet')}
      />
      <S.Title>{t('pages.cabinet.you_dont_have_any_operations_yet')}</S.Title>
      <S.Subtitle>
        {isAccountTab
          ? t('pages.cabinet.here_will_be_displayed_account_history')
          : t('pages.cabinet.here_will_be_displayed_ads_history')}
      </S.Subtitle>
    </S.Container>
  );
}
